// extracted by mini-css-extract-plugin
export default {"percentSpinnerContainer":"PercentSpinner_percentSpinnerContainer__icQSz"};